import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const VerificationComplete = lazy(() => import("@/pages/VerificationComplete"));

export const Route = createFileRoute("/verification-complete")({
  component: VerificationComplete,
});
